import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SimpleChartJSBarChart from '@components/Charts/SimpleChartJSBarChart/SimpleChartJSBarChart';
import { useDisplayUnit, useTheme } from '@hooks';
import { NoDataAvailable } from '@components/Display';

function OperationsChart({ series, loading, primaryXAxisLabel }) {
  const { displayUnit } = useDisplayUnit();
  const { theme } = useTheme();
  const {
    palette: {
      charts: { colorsSameType }
    }
  } = theme;
  const categories = useMemo(() => {
    return ['Hotel & Utilities', 'Drilling Equipment'];
  }, []);

  const chartSeries = categories.map((cat, idx) => ({
    label: cat,
    data: [{ x: cat, y: series?.[0]?.data?.[idx] ?? 0 }],
    borderColor: colorsSameType[0],
    backgroundColor: colorsSameType[0],
    barPercentage: 0.7,
    borderSkipped: true,
    unit: primaryXAxisLabel
  }));

  if (!loading && NoDataAvailable.hasNoData(series)) {
    return <NoDataAvailable height="380px" />;
  }

  return (
    <SimpleChartJSBarChart
      id="system-summary-chart"
      loading={loading}
      unit={primaryXAxisLabel}
      isHorizontal
      tooltipTitle={displayUnit}
      series={chartSeries}
      limitLabelLength={false}
      height={'380px'}
    />
  );
}
OperationsChart.propTypes = {
  loading: PropTypes.bool,
  primaryXAxisLabel: PropTypes.string,
  series: PropTypes.arrayOf(PropTypes.object)
};
OperationsChart.defaultProps = {
  loading: false,
  primaryXAxisLabel: '',
  series: []
};
export default OperationsChart;
